import { ReactComponent as MemberLoggedIn } from '@/assets/img/membership_primary.svg';
import { ReactComponent as MemberNotLoggedIn } from '@/assets/img/membership_gray.svg';
import { ReactComponent as Menu } from '@/assets/img/menu.svg';
import { RootStateOrAny, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

function MemberIcon({ alwaysShow }) {
  const isMember = useSelector<RootStateOrAny, any>(
    (state) => state.memberInfoReducer.isMember
  );

  const memberEnabled = useSelector<RootStateOrAny, any>(
    (state) => state.memberInfoReducer.enabled
  );

  if (!memberEnabled) {
    if (alwaysShow) {
      return (
        <div
          className="d-flex justify-content-center align-items-center"
          role="presentation"
        >
          <Menu />
        </div>
      );
    }

    return <div />;
  }

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      role="presentation"
    >
      {isMember ? <MemberLoggedIn /> : <MemberNotLoggedIn />}
    </div>
  );
}

MemberIcon.defaultProps = {
  alwaysShow: false,
};

MemberIcon.propTypes = {
  alwaysShow: PropTypes.bool,
};

export default MemberIcon;
